<template>
  <div>
    <span class="link" @click="toggleModal">{{ poNumber }}</span>
    <PurchaseOrderModal
      v-if="purchaseOrderModal"
      :purchase-order="purchaseOrder"
      @hide-modal="toggleModal"
      @save-success="refreshTable"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import PurchaseOrderModal from "@/Job/PurchaseOrderModal.vue";
export default {
  components: {
    PurchaseOrderModal
  },
  props: {
    poNumber: {
      type: String,
      default: ""
    },
    poId: {
      type: Number,
      default: null
    },
    jobId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      purchaseOrderModal: false,
      purchaseOrder: null
    };
  },
  watch: {
    purchaseOrderModal(newValue) {
      if (newValue) {
        this.fetchData();
      }
    }
  },
  methods: {
    ...mapActions(["fetchPO", "fetchJob"]),
    fetchData() {
      return Promise.all([
        this.fetchJob({ jobId: this.jobId }),
        this.fetchPO({ id: this.poId, jobId: this.jobId }).then((res) => {
          this.purchaseOrder = res.data;
        })
      ]);
    },
    toggleModal() {
      if (!this.purchaseOrderModal) {
        return this.fetchData().then(
          () => (this.purchaseOrderModal = !this.purchaseOrderModal)
        );
      }
      this.purchaseOrderModal = !this.purchaseOrderModal;
    },
    refreshTable() {
      EventBus.$emit("refresh-datatable");
    }
  }
};
</script>

<style lang="scss" scoped></style>
